var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"step-indicator\">\n<span>\nStep {{curr+1}} of {{steps}}\n</span>\n<div class=\"step-dots\">\n<div ng-repeat=\"dot in arr\" ng-click=\"go($index)\" ng-class=\"['dot',{'dot-full':$index<=curr}]\"></div>\n</div>\n</div>\n";
var id1="app/shared/step-indicator.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;